import Choices from "choices.js";
import * as _ from 'underscore';
import axios from "axios";
export default class CareersSearch {
    constructor() {
        console.log('%c👍🏼 Careers List ', 'color: yellow');
        
        this.careersSearch = document.querySelectorAll('.careers-search');
        
    }
    init() {
        this.careersSearch.forEach((career, i) => {
            let loadMore = career.querySelector('.load-more');
            let clearAll = career.querySelectorAll('.clear-all');
            let careersTemplate = career.querySelector('.careersTemplate');
            let target = career.querySelector('.careers-search__list');

            // Get the value of the hidden input field with ID 'movianto_home_url'
            var homeUrlValue = document.getElementById('movianto_home_url').value;
            let  apiString = homeUrlValue+'/wp-json/movianto/v2/careers'

            let paged = 2; // rendered first page of results from BE
            let loading =  career.querySelector('.careers-search__loading');
            let noResults =  career.querySelector('.careers-search__noResults');
            let params = {
                paged : paged,
                location : '',
                department: '',
                'career-type': ''
            }
            let choicesElem = career.querySelectorAll('.choiceJS');
            let choices = [];

            if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "static-demos.teamlewis.dev") {
                apiString = '../api/careers.json';
            }

            console.log('apiString', apiString);

            loadMore.addEventListener('click', () => {
                loadMoreCareers();
                
            })
            clearAll.forEach( (clear) => {
                clear.addEventListener('click', () => {
                    document.getElementById('next_page_number').value = 1;
                    params = {
                        paged : 1,
                        location : '',
                        department: '',
                        'career-type': ''
                    }
                    target.innerHTML = "";
                    loadMoreCareers();   
    
                    choices.forEach((elem, i) => {
                        elem.removeActiveItems();
                    });   
                })
            })

            choicesElem.forEach((elem, i) => {
                console.log('elem id' , elem.id);
                let choice = new Choices(elem, {
                    searchEnabled: false,
                    itemSelectText: '',
                    placeholder: true,
                    placeholderValue: 'Select',
                    labelId: elem.id + '-label'
                });

                choices.push(choice);
    
                elem.addEventListener('choice', (event) => {
                    document.getElementById('next_page_number').value = 1;
                    target.innerHTML = "";
                    Object.assign(params, { 
                        paged : 1,
                        [event.target.id]: event.detail.choice.value
                    });
                    loadMoreCareers();   
                    }, false,
                );
            });  

            function templateCareers(job) {
                let template = _.template(careersTemplate.innerHTML);
                let compiledResult = template(job);
                target.insertAdjacentHTML( 'beforeend', compiledResult );;
            }
            
      
            function loadMoreCareers() {
                loading.style.display = "inline";
                loadMore.style.display = "none";
                noResults.style.display = "none";
                ajaxMethod();
            }

            function ajaxMethod() {       
                //Get the next page number

                var nextPageNum = document.getElementById('next_page_number').value;  

                //change the value of the next page number
                params.paged = nextPageNum;

                axios.get(apiString, {
                    params: params
                })
                .then( (res) => {
                    loading.style.display = "none";

                    if(res.data.numPosts) {
                        
                        res.data.jobs.forEach( job => {
                            templateCareers(job);
                           
                        })
                        
                        if(nextPageNum * 10 < res.data.numPosts) {
                            loadMore.style.display = "inline";
                        }
                        nextPageNum++;
                        document.getElementById('next_page_number').value = nextPageNum;
                    } else {
                        target.innerHTML = "";
                        noResults.style.display = "inline";
                    }
                    
                })
            }
                           
        })

        
    }
}

